var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DeviceDetail',{key:("deviceDetail-" + _vm.deviceId + "-" + _vm.installationId),attrs:{"installation-id":_vm.installationId,"device-id":_vm.deviceId,"conf":_vm.conf}})}
var staticRenderFns = []

export { render, staticRenderFns }